import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";
import MagnetCursor from "../components/MagnetCursor";
import AboutSection from "../components/Home/AboutSection";
import WorkProcessSection from "../components/WorkProcessSection";
import TeamSection from './../components/Home/TeamMembersSection';

function AboutUs() {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await fetch("https://backend.ohanyanlegal.am/688787d8ff144c502c7/api/about/page/");
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        setAboutData(data);
      } catch (error) {
        console.error("Fetch error:", error);
        setError("Չհաջողվեց բեռնել «Մեր մասին» էջը");
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }
  }, []);

  if (loading) {
    return (
      <div>
        <Preloader />
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Բեռնվում է...</span>
          </div>
          <p className="mt-2">Բեռնվում է «Մեր մասին» էջը...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <Preloader />
        <div className="text-center py-5">
          <p className="text-danger">Սխալ՝ {error}</p>
          <button 
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Կրկին փորձել
          </button>
        </div>
      </div>
    );
  }

  const pageData = aboutData || {};
  const workProcessData = aboutData?.work_processes || [];
  const teamData = aboutData?.team_members || [];

  return (
    <div>
      <Preloader />

      <div
        className="breadcrumb-section bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: `url(${pageData.hero_background || 'assets/img/bg-img/73.jpg'})` }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              {pageData.hero_title || "Մեր մասին"}
            </h2>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      <AboutSection data={pageData} />
      <WorkProcessSection data={pageData} workProcess={workProcessData} />
      <TeamSection data={pageData} team={teamData} />
      <ScrollToTop />
    </div>
  );
}

export default AboutUs;
